import { useDispatch } from "react-redux";
import { ACTIONS } from "../../../../_config";

export function useAppUserAction() {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch({
      type: ACTIONS.USER.LOGOUT,
    });
  };

  const socketInstanceContainer = (socketInstance: any) => {
    dispatch({
      type: ACTIONS.USER.SOCKET_INSTANCE_CONTAINER,
      payload: socketInstance,
    });
  };

  const guestUserId = (guestUserId: any) => {
    dispatch({
      type: ACTIONS.USER.GUEST_USER_ID,
      payload: guestUserId,
    });
  };

  const resetGuestUserId = () => {
    dispatch({
      type: ACTIONS.USER.RESET_GUEST_USER_ID,
    });
  };

  const updateDisplayName = (respData: any) => {
    dispatch({
      type: ACTIONS.USER.UPDATE_DISPLAY_NAME,
      payload: respData,
    });
  };

  const updateDob = (respData: any) => {
    dispatch({
      type: ACTIONS.USER.UPDATE_DOB,
      payload: respData,
    });
  };

  return {
    logout,
    socketInstanceContainer,
    guestUserId,
    resetGuestUserId,
    updateDisplayName,
    updateDob,
  };
}
